import React from 'react';

// for using hooks in class compponents

function Latch({ useHook, params }) {
  useHook(params);

  return <></>;
}

export default Latch;
